import React from 'react';
import { SearchRecord } from 'types/record';

interface CandidateStoriesMultiSelectProps {
  selected: boolean;
  selectValue: SearchRecord | boolean;
  toggleValue: (value: SearchRecord) => void | (() => void);
  displayValue: string;
  date?: string;
  disabled?: boolean;
}

const CandidateStoriesMultiSelect = ({
  displayValue,
  selectValue,
  selected,
  toggleValue,
  date,
  disabled = false,
}: CandidateStoriesMultiSelectProps) => {
  const handleClick = () => {
    if (disabled) return;
    // toggleValue can either be toggleRecord or toggleGeneralInformation
    // toggleRecord takes a Record
    // toggleGeneralInformation takes no arguments
    // for togglegeneralInformation we pass in true but it is ignored
    // @ts-ignore
    toggleValue(selectValue);
  };

  let classes =
    'd-flex justify-content-between tile-option-select tile-option-multi-select p-4 mb-2 rounded';

  if (selected) {
    classes += ' tile-option-select-selected';
  }
  if (disabled) {
    classes += ' tile-option-select-disabled';
  }

  return (
    <div
      className={`${classes}`}
      onClick={!disabled ? handleClick : undefined}
      // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
      role='option'
      tabIndex={0}
      data-testid='candidate-stories-multi-select-checkbox'
    >
      <div>{displayValue}</div>
      <div className='text-very-muted'>{date}</div>
    </div>
  );
};

export default CandidateStoriesMultiSelect;
